const style = {
  getlist: 'style/getlist',
  add: 'style/add',
  update: 'style/update',
  remove: 'style/remove',
  get: 'style/get',
  getall: 'style/getall',
}
export default style
